<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
  )
    .column.m-bottom-2
      .row.middle.m-bottom-05
        simple-svg.m-right-1(
          :class='field.type === kreaCustomFieldTypes.resource ? "black-icon" : "dark-gray-icon"'
          :filepath='customFieldIcon' width='22px' height='22px'
        )
        label.text-small.dark-gray {{ field.name }}
      .container.row.middle.m-left-3(v-if='edition || !valueLabel')
        krea-k-select.select(
          :class='field.type === kreaCustomFieldTypes.resource ? "resource" : "program"'
          v-for='type of types'
          :name='type' noActions small
          :placeholder='innerI18n.t("krea.customFields.placeholder")'
          :emptyOption='innerI18n.t("krea.customFields.emptyOption")'
          @selectOption='updateField'
          :value='getSelectValue(type)'
          :options='getSelectOptions(type)'
        )
      p.text-normal.m-left-3(v-else) {{ valueLabel }}
    template(slot="popover")
      actions(
        @edit='toggleEdition'
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import Actions from './Actions/Actions'
import KreaKSelect from './KreaKSelect'
import kreaActions from '@/mixins/kreaActions'
import { mapActions, mapState } from 'vuex'
import { innerI18n } from '../../../main'
import { kreaCustomFieldTypes } from '@/constants/kreaCustom'
import customFieldIcon from '@/assets/ic_custom_field.svg'

export default {
  mixins: [ kreaActions ],
  components: { Actions, KreaKSelect },
  props: {
    field: { type: Object }
  },
  data() {
    return {
      innerI18n,
      customFieldIcon,
      kreaCustomFieldTypes,
      edition: true
    }
  },
  computed: {
    ...mapState({
      resource: state => state.kreaResource.resource,
      program: state => state.kreaEducationalContent.content
    }),
    content() {
      return this.field.type === kreaCustomFieldTypes.resource ? this.resource : this.program
    },
    types() {
      return [...new Set(this.field.options.map(op => op.type))]
    },
    valueLabel() {
      return this.content.customKreaFieldOptions
        .filter(op => op.customKreaFieldId === this.field.id)
        .map(op => op.name)
        .join(', ')
    }
  },
  methods: {
    ...mapActions([
      'editKreaCustomContentField',
      'editKreaCustomResourceField'
    ]),
    toggleEdition() {
      this.edition = !this.edition
    },
    getSelectOptions(type) {
      return this.field.options
        .filter(op => op.type === type)
        .map(op => ({
          ...op,
          value: op.id,
          label: op.name
        }))
    },
    getSelectValue(type) {
      const option = this.content.customKreaFieldOptions &&
        this.content.customKreaFieldOptions.find(op => op.customKreaFieldId === this.field.id && op.type === type)
      return option ? option.id : null
    },
    updateField(type, optionId, option) {
      let newOptions = this.content.customKreaFieldOptions
        ? this.content.customKreaFieldOptions.filter(op => op.customKreaFieldId === this.field.id)
        : []
      if (optionId) {
        newOptions = [...newOptions.filter(op => op.type !== type), {
          id: optionId,
          type: option.type,
          customKreaFieldId: this.field.id,
          name: option.name,
          referenceId: option.referenceId
        }]
      } else {
        newOptions = newOptions.filter(op => op.type !== type)
      }
      if (this.$route.path.includes('resource')) this.editKreaCustomResourceField({ fieldId: this.field.id, newOptions })
      else this.editKreaCustomContentField({ fieldId: this.field.id, newOptions })
    }
  }
}
</script>

<style lang="scss" scoped>

.container{
  flex-wrap: wrap;
  gap: 10px;
}

.select{
  &.program{
    width: 180px;
  }
  &.resource{
    width: 167px;
  }
}
</style>
